import { useCallback, useEffect, useMemo, useState } from "react";
import { BaseControlledModal } from "../../../../../../common/components/base_controlled_modal";
import { MaskedInput } from "../../../../../../common/components/masked_inputs/masked_input";
import FormContainer from "../../../../../../common/components/form_container";

/**
 * MapaConcretagemCopyModal
 */

type Props = {
  open: boolean;
  saving: boolean;
  loading: boolean;
  onClose: (idMapaConcretagem: number | null, openState: boolean) => void;
  onSubmit: (copyNumber: number) => void;
};

export const MapaConcretagemCopyModal = ({
  open,
  saving,
  loading,
  onClose,
  onSubmit,
}: Props) => {
  const [copyNumber, setCopyNumber] = useState<number | null>(null);
  const [helperText, setHelperText] = useState<string | null>(null);

  const copyNumberMemo = useMemo(() => {
    return copyNumber ? copyNumber.toString() : "";
  }, [
    copyNumber,
  ]);

  useEffect(() => {
    if (open) {
      requestAnimationFrame(() => {
        setCopyNumber(null);
        setHelperText(null);
      });
    }
  }, [
    open,
  ]);

  const handleSubmit = useCallback(() => {
    if (copyNumber) {
      if (!saving && !loading) onSubmit(copyNumber);
    } else {
      setHelperText("Este campo deve ser preenchido!");
    }
  }, [
    copyNumber,
    saving,
    loading,
    onSubmit,
  ]);

  return (
    <BaseControlledModal
      open={open}
      saving={saving}
      loading={loading}
      title='Copiar Mapa de Concretagem'
      onClose={() => onClose(null, false)}
      onSubmit={() => handleSubmit()}>
      <FormContainer title="Gerar Quantas Cópias?" arrangement="fullRow">
        <MaskedInput
          name='copyNumber'
          label='Número de copias'
          mask='000'
          maskPlaceholder='___'
          value={copyNumberMemo}
          helperText={helperText ?? undefined}
          onChange={e => {
            setHelperText(null);
            setCopyNumber(Number(e));
          }}
        />
      </FormContainer>
    </BaseControlledModal>
  );
}